import React, { Component } from 'react';
import TimePicker from 'react-time-picker'

class MyTimePicker extends Component {
  static defaultProps = {
    className: "",
    minTime: null,
    value: new Date(),
    title: ""
  };

  render() {
    const { title, value, onChange, name, minTime, className } = this.props;
    return (
      <React.Fragment>
        <div className={"row my-font-sz-08 my-font-wg-500 " + className}>
          {title}
        </div>
        <div className={"row text-dark " + className}>
          <TimePicker clearIcon={null}
                      value={value}
                      minTime={minTime}
                      disableClock={true}
                      locale={"es"}
                      onChange={onChange}
                      name={name}
                      className="bg-white w-100"/>
        </div>
        <div className="row mb-3">

        </div>
      </React.Fragment>
    );
  }
}

export default MyTimePicker;
